import { Component, OnInit, OnDestroy, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AlarmsService, GetAlarmsStatisticsResponse } from '../../../../core/services/alarms.service';
import { OmniMqttService } from '../../../../core/mqtt/omni-mqtt.service';

interface SystemStatVM {
    systemName: string;
    unclosedCount: number;
    percentage: number;
    icon: string;
}

@Component({
    selector: 'app-system-stats',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './system-stats.component.html',
})
export class SystemStatsComponent implements OnInit, OnDestroy {
    private alarmsService = inject(AlarmsService);
    private mqttService = inject(OmniMqttService);
    private alarmSub?: Subscription;

    statsData = signal<GetAlarmsStatisticsResponse | null>(null);
    mappedStats = signal<SystemStatVM[]>([]);

    ngOnInit() {
        this.loadStats();
        // 收到即時告警封包時重新抓統計
        this.alarmSub = this.mqttService.alarms$.subscribe(() => this.loadStats());
    }

    ngOnDestroy() {
        this.alarmSub?.unsubscribe();
    }

    private loadStats() {
        this.alarmsService.apiGetAlarmsStatistics().subscribe({
            next: (data) => {
                this.statsData.set(data);
                this.mappedStats.set(this.mapToVM(data.systemStatistics));
            }
        });
    }

    private mapToVM(stats: GetAlarmsStatisticsResponse['systemStatistics']): SystemStatVM[] {
        const iconMap: Record<string, string> = {
            '空調系統': 'ci-air-conditioner',
            '風機系統': 'ci-fan',
            '門禁系統': 'ci-access-control',
            'CCTV監視系統': 'ci-cctv',
            '電力系統': 'ci-electricity',
            '照明系統': 'ci-lighting',
            '空氣品質系統': 'ci-air-quality',
            '會議室系統': 'ci-meet-room',
            '通訊系統': 'ci-device'
        };

        return stats.map(s => ({
            systemName: s.systemName,
            unclosedCount: s.unclosedCount,
            percentage: s.percentage,
            icon: iconMap[s.systemName] || 'pi-cog'
        }));
    }
}
